exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-layout[data-v-3b61965b]{width:1200px;margin:0 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.content-layout .l[data-v-3b61965b]{width:800px}.content-layout .r[data-v-3b61965b]{width:300px}", ""]);

// exports
